/* eslint-disable no-unused-vars */
export default class Vagas {

  constructor(id = 0, nome = "") {
    this.id = 0;
    this.codigo = "0000";
    this.nome = "";
    this.numero_vagas = 1;
    this.atribuicoes = "";
    this.bairro = "";
    this.horario_vaga
    this.salario_vaga = "";
    this.obs_candidato = "";
  }

}

